import { featureTypeCreateUrlBuilder, featureTypeUrlBuilder } from "@/lib/url-builder";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import CardGridView from "../CardGridView";
import { useSiteName } from "@/hooks/useSiteName";
import { FeatureTypeService, type FeatureType } from "@/services/FeatureTypeService";
import { Pencil } from "lucide-react";
import { Loading } from "../Loading";

export interface FeatureTypeListProps {
  subType: string;
}

const FeatureTaskList: React.FC<FeatureTypeListProps> = ({subType}) => {
  const params = useParams();
  const [featureTypeCodes, setFeatureTypeCodes] = useState<FeatureType[]>([])
  const { siteName } = useSiteName(params.siteId!);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeActions = async () => {
      const featureTypes = await FeatureTypeService.getBySiteId(params.siteId!)
      setFeatureTypeCodes(featureTypes.filter(f => f.subType === subType).sort((a, b) => a.name.localeCompare(b.name)))
      setIsLoading(false);
    };
    initializeActions();
  }, []);
    if (isLoading) {
      return <Loading message="Loading feature types..." isLoading={isLoading} />;
    }

    return(
      <CardGridView
        title={`Site: ${siteName}`}
        editPageUrl={(site: string, id: string) => featureTypeUrlBuilder(site, id)}
        createPageUrl={featureTypeCreateUrlBuilder(params.siteId!)}
        items={featureTypeCodes}
        renderContentItem={(featureType: FeatureType) => (
            <div className="space-y-1">
              <div className="flex items-center gap-4 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  {featureType.name}
                </div>
                <div className="flex items-center gap-2">
                   {featureType.reference}
                </div>                  
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  {featureType.description}
                </div>
              </div>
            </div>
        )}
        tableHeaders={[
          { id: "name", child: <>Name</> },
          { id: "description", child: <>Description</> },
          { id: "reference", child: <>Reference</> },
          { id: "actions", child: <>Edit</>, },
        ]}
        tableContentItem={(featureType: FeatureType) => [
          <Link 
            to={featureTypeUrlBuilder(params.siteId!, featureType.id)}
            className="hover:text-blue-600 transition-colors duration-200 cursor-pointer">
            {featureType.name}
          </Link>,
          <>{featureType.description}</>,
          <>{featureType.reference}</>,
          <Link to={featureTypeUrlBuilder(params.siteId!, featureType.id)}>
            <Pencil
              className="inline-block mr-1 h-4 w-4 hover:text-blue-600 transition-colors duration-200 cursor-pointer"
              aria-label={`Edit ${featureType.name}`}
            />
          </Link>,
        ]}
      />
    
  );
};

export default FeatureTaskList;